import './App.css';
import ImageHeader from './components/image-header';
import styled from 'styled-components'
import AboutUs from './components/AboutUs';
import Music from './components/Music'
import facebookSVG from './assets/social-icons/svg/045-facebook.svg'
import instaSVG from './assets/social-icons/svg/instagram-2016.svg'
import youtubeSVG from './assets/social-icons/svg/002-youtube.svg'
import Contact from './components/Contact';
import Events from './components/Events'




function App() {

  const sidebarwidth = '7rem'

  const Div = styled.div`
    display:grid;
    grid-template-columns:${sidebarwidth} calc(100% - ${sidebarwidth});;
    gap:0;
    width:100vw;
    margin:0;
    padding:0;
    overflow:hidden;
  `

  const Sidebar = styled.div`
  background:black;
  display:flex;
  height:100vh;
  width:${sidebarwidth};
  position:fixed;
  flex-direction:column;
    & a{
      text-decoration:none;
      text-align:left;
      color:white;
      padding:1rem 0.5rem;
      transition:0.3s;
      position:relative;
      z-index:1;
      overflow:hidden;

      &::after{
        background:white;
        content:"";
        position:absolute;
        height:100%;
        width:0%;
        top:0;
        left:0;
        transition:0.3s;
        z-index:-1;
        border-top-right-radius:2rem;
        border-bottom-right-radius:2rem;
        
      }

      &:hover{
        color:grey;
        color:black;

        &::after{
          width:130%;
          border-top-right-radius:0rem;
          border-bottom-right-radius:0rem;
        }
      }

    }


    & img{
      width:2.5rem;
      height:2.5rem;
      margin:1rem auto;
      display:inline-block;
      transition:0.25s;
      cursor:pointer;
      
    }
  `

  const ImageFlexCol = styled.div`
    display:flex;
    border-top:1px solid rgba(255,255,255,0.175);
    margin-top:1rem;
    padding-top:1rem;
    width:95%;
    align-items:center;
    flex-direction:column;
    & a{
      width:100%;
      display:block;
      margin:0;
      padding:0;
      display:flex;
      justify-content:center;
      &::after{
        background:transparent;
      }
      &:hover{
        transform:scale(1.45);
      }
    }
  `

  


  return (
    <Div className="App">
      <div id="side-bar" style={{height:'100vh',width:'100%'}}>
      <Sidebar>
          <a href="#">Home</a>
          <a href="#about-us">About Us</a>
          <a href="#music">Music</a>
          <a href="#events">Events</a>
          <a href="#contact">Contact</a>
          <ImageFlexCol>
            <a target="_blank" href="https://www.instagram.com/Exalted_Christian_Band/?fbclid=IwAR1XBbD9vd7KPgNgbuuDgUkB_Y2i4uVPWgcmkV-2cMkVmhaxmaaMrAd97I8"><img src={instaSVG} alt=""/></a>
            <a target="_blank" href="https://www.facebook.com/exaltedchristianband"><img src={facebookSVG} alt=""/></a>
            <a target="_blank" href="https://l.facebook.com/l.php?u=https%3A%2F%2Fwww.youtube.com%2Fchannel%2FUCvRXM1cFHBSyhjNw5LiUfRQ%3Ffbclid%3DIwAR28q7l2ClOCl0xBtrbJvWncYnC1YO_lWNpG7on5bL9zYB3NKmwBBGP1kMQ&h=AT095N38_Joh_5g2rb271lEbX39tngqrrERI28whoO0h4iO8yz03dsFAsw8XrEPnaBo3k0LqmsXXf73CC4618quKrabXAp6yNnVD5DDGdj8JvSpBFYIyWrQkSbHelTm0cPy7spk4C_xK"><img src={youtubeSVG} alt=""/></a>
            
          </ImageFlexCol>
          
      </Sidebar>
      </div>
     
      <main style={{maxWidth:'100%'}}>
        <div id="main-content">
          <ImageHeader/>
          <AboutUs></AboutUs>
          
         
          <div id="music">
            <Music></Music>
          </div>
          <div id="events">
            <Events></Events>
           </div>
          <div id="contact">
            <Contact></Contact>
          </div>
        </div>
      </main>
    
      
    </Div>
  );
}

export default App;
